import { useQuery } from "@tanstack/react-query";
import { SystemNotifications } from "@graylog/server-api";
import { NOTIFICATIONS_QUERY_KEY } from "components/notifications/constants";
const POLL_INTERVAL = 3e3;
const useNotifications = () => {
  const { data, isLoading } = useQuery({
    queryKey: NOTIFICATIONS_QUERY_KEY,
    queryFn: SystemNotifications.listNotifications,
    refetchInterval: POLL_INTERVAL
  });
  return { data, isLoading };
};
export default useNotifications;
